<div *ngIf="!admin" class="modal-dialog modal-lg modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLongTitle">
        {{ "orgstyle.header" | trans }}
      </h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body p-0">
      <div class="pl-3 pr-3">
        <h6 class="pt-3">{{ "orgstyle.organisationcolors" | trans }}</h6>
        <div class="form-group row pt-2">
          <label for="staticMainColor" class="col col-form-label style-label">{{ "orgstyle.mainorganizationalcolor" |
            trans }}
          </label>
          <div class="col">
            <input [ngClass]="{ 'border-danger': !orgstyle.mainColor }" style="font-size: 13px" type="color"
              class="form-control" id="staticMainColor" name="mainColor" [(ngModel)]="orgstyle.mainColor" />
          </div>
        </div>
        <div class="form-group row border-bottom pb-3">
          <label for="staticSecoundColor" class="col col-form-label style-label">{{ "orgstyle.secondorganizationalcolor"
            | trans }}
          </label>
          <div class="col">
            <input [ngClass]="{ 'border-danger': !orgstyle.negMainColor }" style="font-size: 13px" type="color"
              class="form-control" id="staticSecoundColor" name="negMainColor" [(ngModel)]="orgstyle.negMainColor" />
          </div>
        </div>
        <h6 class="pb-2">{{ "orgstyle.fonts" | trans }}</h6>
        <div class="form-group row">
          <label for="orgFont" class="col col-form-label style-label">{{
            "orgstyle.titlefont" | trans
            }}</label>
          <div class="col">
            <select [ngClass]="{ 'border-danger': !orgstyle.orgFont }" [(ngModel)]="orgstyle.orgFont"
              class="form-control form-control-sm" name="orgFont">
              <option value="Lato">Lato</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Roboto">Roboto</option>
              <option value="Telegraf">Telegraf</option>
              <option value="Oswald">Oswald</option>
              <option value="Poppins">Poppins</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="orgContentFont" class="col col-form-label style-label">{{
            "orgstyle.contentfont" | trans
            }}</label>
          <div class="col">
            <select [ngClass]="{ 'border-danger': !orgstyle.orgContentFont }" [(ngModel)]="orgstyle.orgContentFont"
              class="form-control form-control-sm" name="orgContentFont">
              <option value="Lato">Lato</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Roboto">Roboto</option>
              <option value="Telegraf">Telegraf</option>
              <option value="Oswald">Oswald</option>
              <option value="Poppins">Poppins</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button [ngClass]="{ 'btn fa-bgcolor border-0 reset-btn': resettoggler }" type="button"
            class="btn-close float-left mb-3 ml-3 w-75" data-dismiss="modal">
            <h6 class="btn-save-text">{{ "orgstyle.close" | trans }}</h6>
          </button>
        </div>
        <div class="col">
          <button [ngClass]="{ 'btn fa-bgcolor border-0 reset-btn': resettoggler }" (click)="updateOrgStyle()"
            type="button" data-dismiss="modal" class="btn-save float-right w-75 mb-3 mr-3">
            <h6 class="btn-save-text">{{ "orgstyle.savechanges" | trans }}</h6>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!---admin mode starts here--->
<div *ngIf="admin" class="modal-dialog modal-lg modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLongTitle">
        {{ "orgstyle.header" | trans }}
      </h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body p-0">
      <form>
        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingZero">
              <h5 class="mb-0">
                <a class="cursor-pointer font-weight-light f-18" data-toggle="collapse" data-target="#collapseZero"
                  aria-expanded="true" aria-controls="collapseZero">{{ "orgstyle.navigation" | trans }}</a>
                <label class="font-weight-light f-18 pl-1" *ngIf="
                    !orgstyle.topnavmenusize ||
                    !orgstyle.topnavnmenuweight ||
                    !orgstyle.topnavmenuweightactive ||
                    !orgstyle.topnavmenufont ||
                    !orgstyle.topnavmenuiconcolor ||
                    !orgstyle.topnavmenuiconcolorhover ||
                    !orgstyle.topnavmenuiconbg ||
                    !orgstyle.topnavmenuiconbghover ||
                    !orgstyle.topnavnmenuborderbottom ||
                    !orgstyle.footernaviconbg ||
                    !orgstyle.footernaviconbghover ||
                    !orgstyle.footernaviconcolor ||
                    !orgstyle.footernaviconcolorhover
                  ">{{ "orgstyle.missingsettings" | trans }}</label>
              </h5>
            </div>
            <div id="collapseZero" class="collapse" aria-labelledby="headingZero" data-parent="#accordion">
              <div class="card-body">
                <h6>{{ "orgstyle.navlinks" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="topnavmenusize" class="col col-form-label style-label">{{ "orgstyle.lastmnavlinkssizeonth"
                    | trans }}</label>
                  <div class="col">
                    <select [(ngModel)]="orgstyle.topnavmenusize" class="form-control form-control-sm"
                      [ngClass]="{ 'border-danger': !orgstyle.topnavmenusize }" name="topnavmenusize">
                      <option value="12px">
                        {{ "orgstyle.extrasmall" | trans }} - 12px
                      </option>
                      <option value="14px">
                        {{ "orgstyle.small" | trans }} - 14px
                      </option>
                      <option value="16px">
                        {{ "orgstyle.medium" | trans }} - 16px
                      </option>
                      <option value="18px">
                        {{ "orgstyle.big" | trans }} - 18px
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="topnavnmenuweight" class="col col-form-label style-label">{{ "orgstyle.navlinkweight" |
                    trans }}</label>
                  <div class="col">
                    <select [ngClass]="{
                        'border-danger': !orgstyle.topnavnmenuweight
                      }" [(ngModel)]="orgstyle.topnavnmenuweight" class="form-control form-control-sm"
                      name="topnavnmenuweight">
                      <option value="100">
                        {{ "orgstyle.thin" | trans }} - 100
                      </option>
                      <option value="300">
                        {{ "orgstyle.light" | trans }} - 300
                      </option>
                      <option value="400">
                        {{ "orgstyle.regular" | trans }} - 400
                      </option>
                      <option value="500">
                        {{ "orgstyle.medium" | trans }} - 500
                      </option>
                      <option value="600">
                        {{ "orgstyle.semibold" | trans }} - 600
                      </option>
                      <option value="700">
                        {{ "orgstyle.bold" | trans }} - 700
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="topnavmenuweightactive" class="col col-form-label style-label">{{
                    "orgstyle.activenavlinkweight" | trans }}</label>
                  <div class="col">
                    <select [ngClass]="{
                        'border-danger': !orgstyle.topnavmenuweightactive
                      }" [(ngModel)]="orgstyle.topnavmenuweightactive" class="form-control form-control-sm"
                      name="topnavmenuweightactive">
                      <option value="100">
                        {{ "orgstyle.thin" | trans }} - 100
                      </option>
                      <option value="300">
                        {{ "orgstyle.light" | trans }} - 300
                      </option>
                      <option value="400">
                        {{ "orgstyle.regular" | trans }} - 400
                      </option>
                      <option value="500">
                        {{ "orgstyle.medium" | trans }} - 500
                      </option>
                      <option value="600">
                        {{ "orgstyle.semibold" | trans }} - 600
                      </option>
                      <option value="700">
                        {{ "orgstyle.bold" | trans }} - 700
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row pb-3 border-bottom">
                  <label for="topnavmenufont" class="col col-form-label style-label">{{ "orgstyle.navlinkfont" | trans
                    }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.topnavmenufont }"
                      [(ngModel)]="orgstyle.topnavmenufont" class="form-control form-control-sm" name="topnavmenufont">
                      <option value="Lato">Lato</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Roboto">Roboto</option>
                      <option value="Telegraf">Telegraf</option>
                      <option value="Oswald">Oswald</option>
                      <option value="Poppins">Poppins</option>
                    </select>
                  </div>
                </div>
                <h6>{{ "orgstyle.navicons" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.naviconcolor" |
                    trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.topnavmenuiconcolor
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="topnavmenuiconcolor" [(ngModel)]="orgstyle.topnavmenuiconcolor" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.naviconcoloronhover"
                    | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.topnavmenuiconcolorhover
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="topnavmenuiconcolorhover" [(ngModel)]="orgstyle.topnavmenuiconcolorhover" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{
                    "orgstyle.naviconbackgroundcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.topnavmenuiconbg
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="topnavmenuiconbg" [(ngModel)]="orgstyle.topnavmenuiconbg" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{
                    "orgstyle.naviconbackgroundcoloronhover" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.topnavmenuiconbghover
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="topnavmenuiconbghover" [(ngModel)]="orgstyle.topnavmenuiconbghover" />
                  </div>
                </div>
                <div class="form-group row pb-3 border-bottom">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.mainnavbordercolor"
                    | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.topnavnmenuborderbottom
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="topnavnmenuborderbottom" [(ngModel)]="orgstyle.topnavnmenuborderbottom" />
                  </div>
                </div>
                <h6>{{ "orgstyle.bottomnavicons" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="footernaviconbg" class="col col-form-label style-label">{{
                    "orgstyle.bottomnaviconbackgroundcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.footernaviconbg }" style="font-size: 13px"
                      type="color" class="form-control" id="footernaviconbg" name="footernaviconbg"
                      [(ngModel)]="orgstyle.footernaviconbg" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="footernaviconbghover" class="col col-form-label style-label">{{
                    "orgstyle.bottomnaviconbackgroundcoloronhover" | trans
                    }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.footernaviconbghover
                      }" style="font-size: 13px" type="color" class="form-control" id="footernaviconbghover"
                      name="footernaviconbghover" [(ngModel)]="orgstyle.footernaviconbghover" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="footernavniconcolor" class="col col-form-label style-label">{{
                    "orgstyle.bottomnaviconcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.footernaviconcolor
                      }" style="font-size: 13px" type="color" class="form-control" id="footernavniconcolor"
                      name="footernavniconcolor" [(ngModel)]="orgstyle.footernaviconcolor" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="footernavniconcolorhover" class="col col-form-label style-label">{{
                    "orgstyle.bottomnaviconcoloronhover" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.footernaviconcolorhover
                      }" style="font-size: 13px" type="color" class="form-control" id="footernavniconcolorhover"
                      name="footernavniconcolorhover" [(ngModel)]="orgstyle.footernaviconcolorhover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingHalf">
              <h5 class="mb-0">
                <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                  data-target="#collapseHalf" aria-expanded="true" aria-controls="collapseHalf">{{
                  "orgstyle.pageheaders" | trans }}</a>
                <label class="font-weight-light f-18 pl-1" *ngIf="
                    !orgstyle.pagetitleweight ||
                    !orgstyle.pagetitlesize ||
                    !orgstyle.pagetitlefont ||
                    !orgstyle.pagetitlecolor ||
                    !orgstyle.pagetitlesubsize ||
                    !orgstyle.pagetitlesubweight ||
                    !orgstyle.pagetitlesubcolor ||
                    !orgstyle.pagetitlesubfont
                  ">{{ "orgstyle.missingsettings" | trans }}</label>
              </h5>
            </div>
            <div id="collapseHalf" class="collapse" aria-labelledby="headingHalf" data-parent="#accordion">
              <div class="card-body">
                <h6>{{ "orgstyle.pageheaderoptions" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="pagetitleweight" class="col col-form-label style-label">{{ "orgstyle.pagetitleweight" |
                    trans }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.pagetitleweight }"
                      [(ngModel)]="orgstyle.pagetitleweight" class="form-control form-control-sm"
                      name="pagetitleweight">
                      <option value="100">
                        {{ "orgstyle.thin" | trans }} - 100
                      </option>
                      <option value="300">
                        {{ "orgstyle.light" | trans }} - 300
                      </option>
                      <option value="400">
                        {{ "orgstyle.regular" | trans }} - 400
                      </option>
                      <option value="500">
                        {{ "orgstyle.medium" | trans }} - 500
                      </option>
                      <option value="600">
                        {{ "orgstyle.semibold" | trans }} - 600
                      </option>
                      <option value="700">
                        {{ "orgstyle.bold" | trans }} - 700
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="pagetitlesize" class="col col-form-label style-label">{{ "orgstyle.pagetitlesize" | trans
                    }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.pagetitlesize }"
                      [(ngModel)]="orgstyle.pagetitlesize" class="form-control form-control-sm" name="pagetitlesize">
                      <option value="14px">
                        {{ "orgstyle.extrasmall" | trans }} - 14px
                      </option>
                      <option value="16px">
                        {{ "orgstyle.small" | trans }} - 16px
                      </option>
                      <option value="18px">
                        {{ "orgstyle.medium" | trans }} - 18px
                      </option>
                      <option value="20px">
                        {{ "orgstyle.big" | trans }} - 20px
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="pagetitlefont" class="col col-form-label style-label">{{ "orgstyle.pagetitlefont" | trans
                    }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.pagetitlefont }"
                      [(ngModel)]="orgstyle.pagetitlefont" class="form-control form-control-sm" name="pagetitlefont">
                      <option value="Lato">Lato</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Roboto">Roboto</option>
                      <option value="Telegraf">Telegraf</option>
                      <option value="Oswald">Oswald</option>
                      <option value="Poppins">Poppins</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row pb-3 border-bottom">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.pagetitlecolor" |
                    trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.pagetitlecolor }" style="font-size: 13px"
                      type="color" class="form-control" id="staticMainBorder" name="pagetitlecolor"
                      [(ngModel)]="orgstyle.pagetitlecolor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.pagesubtitleoptions" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="pagetitlesubsize" class="col col-form-label style-label">{{ "orgstyle.pagetitlesubsize" |
                    trans }}</label>
                  <div class="col">
                    <select [ngClass]="{
                        'border-danger': !orgstyle.pagetitlesubsize
                      }" [(ngModel)]="orgstyle.pagetitlesubsize" class="form-control form-control-sm"
                      name="pagetitlesubsize">
                      <option value="12px">
                        {{ "orgstyle.extrasmall" | trans }} - 12px
                      </option>
                      <option value="14px">
                        {{ "orgstyle.small" | trans }} - 14px
                      </option>
                      <option value="16px">
                        {{ "orgstyle.medium" | trans }} - 16px
                      </option>
                      <option value="18px">
                        {{ "orgstyle.big" | trans }} - 18px
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="pagetitlesubweight" class="col col-form-label style-label">{{
                    "orgstyle.pagetitlesubweight" | trans }}</label>
                  <div class="col">
                    <select [ngClass]="{
                        'border-danger': !orgstyle.pagetitlesubweight
                      }" [(ngModel)]="orgstyle.pagetitlesubweight" class="form-control form-control-sm"
                      name="pagetitlesubweight">
                      <option value="100">
                        {{ "orgstyle.thin" | trans }} - 100
                      </option>
                      <option value="300">
                        {{ "orgstyle.light" | trans }} - 300
                      </option>
                      <option value="400">
                        {{ "orgstyle.regular" | trans }} - 400
                      </option>
                      <option value="500">
                        {{ "orgstyle.medium" | trans }} - 500
                      </option>
                      <option value="600">
                        {{ "orgstyle.semibold" | trans }} - 600
                      </option>
                      <option value="700">
                        {{ "orgstyle.bold" | trans }} - 700
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="pagetitlesubcolor" class="col col-form-label style-label">{{ "orgstyle.pagetitlesubcolor"
                    | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.pagetitlesubcolor
                      }" style="font-size: 13px" type="color" class="form-control" id="pagetitlesubcolor"
                      name="pagetitlesubcolor" [(ngModel)]="orgstyle.pagetitlesubcolor" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="pagetitlesubfont" class="col col-form-label style-label">{{ "orgstyle.pagetitlesubfont" |
                    trans }}</label>
                  <div class="col">
                    <select [(ngModel)]="orgstyle.pagetitlesubfont" class="form-control form-control-sm"
                      name="pagetitlesubfont">
                      <option value="Lato">Lato</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Roboto">Roboto</option>
                      <option value="Telegraf">Telegraf</option>
                      <option value="Oswald">Oswald</option>
                      <option value="Poppins">Poppins</option>

                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">{{ "orgstyle.colors" |
                  trans }}</a>
                <label class="font-weight-light f-18 pl-1" *ngIf="
                    !orgstyle.mainColor ||
                    !orgstyle.negMainColor ||
                    !orgstyle.portaliconcolor ||
                    !orgstyle.portaliconcolorhover ||
                    !orgstyle.portaliconbg ||
                    !orgstyle.portaliconbghover ||
                    !orgstyle.orgtitlecolor ||
                    !orgstyle.orgFontColor ||
                    !orgstyle.orgiconColor ||
                    !orgstyle.orgiconhoverColor ||
                    !orgstyle.buttontextColor ||
                    !orgstyle.buttonbgcolor ||
                    !orgstyle.buttonbghovercolor ||
                    !orgstyle.buttontextHoverColor ||
                    !orgstyle.tabletextcolor ||
                    !orgstyle.customerpagelabelcolor ||
                    !orgstyle.dropdowntextcolor
                  ">{{ "orgstyle.missingsettings" | trans }}</label>
              </h5>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">
                <h6>{{ "orgstyle.organisationcolors" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="staticMainColor" class="col col-form-label style-label">{{
                    "orgstyle.mainorganizationalcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.mainColor }" style="font-size: 13px" type="color"
                      class="form-control" id="staticMainColor" name="mainColor" [(ngModel)]="orgstyle.mainColor" />
                  </div>
                </div>
                <div class="form-group row border-bottom pb-3">
                  <label for="staticSecoundColor" class="col col-form-label style-label">{{
                    "orgstyle.secondorganizationalcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.negMainColor }" style="font-size: 13px" type="color"
                      class="form-control" id="staticSecoundColor" name="negMainColor"
                      [(ngModel)]="orgstyle.negMainColor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.portaliconcolors" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.portaliconcolor" |
                    trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.portaliconcolor }" style="font-size: 13px"
                      type="color" class="form-control" id="staticMainBorder" name="portaliconcolor"
                      [(ngModel)]="orgstyle.portaliconcolor" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{
                    "orgstyle.portaliconcoloronhover" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.portaliconcolorhover
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="portaliconcolorhover" [(ngModel)]="orgstyle.portaliconcolorhover" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.portalbgcolor" |
                    trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.portaliconbg }" style="font-size: 13px" type="color"
                      class="form-control" id="staticMainBorder" name="portaliconbg"
                      [(ngModel)]="orgstyle.portaliconbg" />
                  </div>
                </div>
                <div class="form-group row pb-3 border-bottom">
                  <label for="staticMainBorder" class="col col-form-label style-label">{{
                    "orgstyle.portalbgcoloronhover" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.portaliconbghover
                      }" style="font-size: 13px" type="color" class="form-control" id="staticMainBorder"
                      name="portaliconbghover" [(ngModel)]="orgstyle.portaliconbghover" />
                  </div>
                </div>
                <h6>{{ "orgstyle.fontcolors" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="staticOrgtitlecolor" class="col col-form-label style-label">{{ "orgstyle.titlecolor" |
                    trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.orgtitlecolor }" style="font-size: 13px" type="color"
                      class="form-control" id="staticOrgtitlecolor" name="orgtitlecolor"
                      [(ngModel)]="orgstyle.orgtitlecolor" />
                  </div>
                </div>
                <div class="form-group row border-bottom pb-3">
                  <label for="staticFontColor" class="col col-form-label style-label">{{ "orgstyle.fontcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.orgFontColor }" style="font-size: 13px" type="color"
                      class="form-control" id="staticFontColor" name="orgFontColor"
                      [(ngModel)]="orgstyle.orgFontColor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.iconcolors" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="staticiconcolor" class="col col-form-label style-label">{{ "orgstyle.iconcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.orgiconColor }" style="font-size: 13px" type="color"
                      class="form-control" id="staticiconcolor" name="orgiconColor"
                      [(ngModel)]="orgstyle.orgiconColor" />
                  </div>
                </div>
                <div class="form-group row border-bottom pb-3">
                  <label for="staticiconhovercolor" class="col col-form-label style-label">{{ "orgstyle.iconhovercolor"
                    | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.orgiconhoverColor
                      }" style="font-size: 13px" type="color" class="form-control" id="staticiconhovercolor"
                      name="orgiconhoverColor" [(ngModel)]="orgstyle.orgiconhoverColor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.buttoncolors" | trans }}</h6>
                <div class="form-group row pt-2">
                  <label for="staticbuttontextColor" class="col col-form-label style-label">{{
                    "orgstyle.buttontextcolor" | trans }}</label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.buttontextColor }" style="font-size: 13px"
                      type="color" class="form-control" id="staticbuttontextColor" placeholder="5px"
                      name="buttontextColor" [(ngModel)]="orgstyle.buttontextColor" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticbuttonBgColor" class="col col-form-label style-label">{{
                    "orgstyle.buttonbackgroundcolor" | trans }}</label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.buttonbgcolor }" style="font-size: 13px" type="color"
                      class="form-control" id="staticbuttonBgColor" name="buttonbgColor"
                      [(ngModel)]="orgstyle.buttonbgcolor" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticbuttonHoverBgColor" class="col col-form-label style-label">{{
                    "orgstyle.buttonbackgroundhovercolor" | trans }}</label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.buttonbghovercolor
                      }" style="font-size: 13px" type="color" class="form-control" id="staticbuttonHoverBgColor"
                      name="buttonbgHoverColor" [(ngModel)]="orgstyle.buttonbghovercolor" />
                  </div>
                </div>
                <div class="form-group row pb-3 border-bottom">
                  <label for="staticbuttonHovertextColor" class="col col-form-label style-label">{{
                    "orgstyle.buttontexthovercolor" | trans }}</label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.buttontextHoverColor
                      }" style="font-size: 13px" type="color" class="form-control" id="staticbuttonHovertextColor"
                      name="buttontextHoverColor" [(ngModel)]="orgstyle.buttontextHoverColor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.tablecolors" | trans }}</h6>
                <div class="form-group row">
                  <label for="tabletextcolor" class="col col-form-label style-label">{{ "orgstyle.tabletextcolor" |
                    trans }}</label>
                  <div class="col">
                    <input [ngClass]="{ 'border-danger': !orgstyle.tabletextcolor }" style="font-size: 13px"
                      type="color" class="form-control" id="tabletextcolor" name="tabletextcolor"
                      [(ngModel)]="orgstyle.tabletextcolor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.customerpagecolors" | trans }}</h6>
                <div class="form-group row">
                  <label for="staticcustomerpagelabelcolor" class="col col-form-label style-label">{{
                    "orgstyle.customerpagetextcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.customerpagelabelcolor
                      }" style="font-size: 13px" type="color" class="form-control" id="staticcustomerpagelabelcolor"
                      name="customerpagelabelcolor" [(ngModel)]="orgstyle.customerpagelabelcolor" />
                  </div>
                </div>
                <h6>{{ "orgstyle.dropdowncolors" | trans }}</h6>
                <div class="form-group row">
                  <label for="staticdropdownFontColor" class="col col-form-label style-label">{{
                    "orgstyle.dropdowntextcolor" | trans }}
                  </label>
                  <div class="col">
                    <input [ngClass]="{
                        'border-danger': !orgstyle.dropdowntextcolor
                      }" style="font-size: 13px" type="color" class="form-control" id="staticdropdownFontColor"
                      name="dropdowntextcolor" [(ngModel)]="orgstyle.dropdowntextcolor" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">{{ "orgstyle.fonts" |
                  trans }}</a>
                <label class="font-weight-light f-18 pl-1" *ngIf="
                    !orgstyle.orgFont ||
                    !orgstyle.orgContentFont ||
                    !orgstyle.orgBrandWeight
                  ">{{ "orgstyle.missingsettings" | trans }}</label>
              </h5>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
              <div class="card-body">
                <div class="form-group row">
                  <label for="orgFont" class="col col-form-label style-label">{{
                    "orgstyle.titlefont" | trans
                    }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.orgFont }" [(ngModel)]="orgstyle.orgFont"
                      class="form-control form-control-sm" name="orgFont">
                      <option value="Lato">Lato</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Roboto">Roboto</option>
                      <option value="Telegraf">Telegraf</option>
                      <option value="Oswald">Oswald</option>
                      <option value="Poppins">Poppins</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="orgContentFont" class="col col-form-label style-label">{{ "orgstyle.contentfont" | trans
                    }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.orgContentFont }"
                      [(ngModel)]="orgstyle.orgContentFont" class="form-control form-control-sm" name="orgContentFont">
                      <option value="Lato">Lato</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Roboto">Roboto</option>
                      <option value="Telegraf">Telegraf</option>
                      <option value="Oswald">Oswald</option>
                      <option value="Poppins">Poppins</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="orgBrandWeight" class="col col-form-label style-label">{{ "orgstyle.titleweight" | trans
                    }}</label>
                  <div class="col">
                    <select [ngClass]="{ 'border-danger': !orgstyle.orgBrandWeight }"
                      [(ngModel)]="orgstyle.orgBrandWeight" class="form-control form-control-sm" name="orgBrandWeight">
                      <option value="100">thin - 100</option>
                      <option value="300">light - 300</option>
                      <option value="400">regular - 400</option>
                      <option value="500">medium - 500</option>
                      <option value="600">semibold - 600</option>
                      <option value="700">bold - 700</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">{{ "orgstyle.logos" |
                  trans }}</a>
                <label class="font-weight-light f-18 pl-1" *ngIf="!orgstyle.orgfavicon || !orgstyle.logoformat">{{
                  "orgstyle.missingsettings" | trans }}</label>
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                <div class="form-group row ml-2 mr-2">
                  <label for="staticFavicon" class="col col-form-label style-label">{{ "orgstyle.icon" | trans
                    }}</label>
                  <input [ngClass]="{ 'border-danger': !orgstyle.orgfavicon }" style="font-size: 13px" type="text"
                    class="form-control" id="staticFavicon" name="orgfavicon" [(ngModel)]="orgstyle.orgfavicon" />
                </div>
              </div>
              <!---<div class="form-group row ml-2 mr-2">
                        <label for="staticlogoformat" class="col col-form-label style-label">{{ 'orgstyle.logoformat' | trans }}</label>
                        <div class="col">
                          <select [ngClass]="{'border-danger': !orgstyle.logoformat}" [(ngModel)]="orgstyle.logoformat" class="form-control form-control-sm" name="logoformat">
                           <<option value="square" >{{ 'orgstyle.square50x50' | trans }}</option>
                            <option value="squareandtitle">{{ 'orgstyle.square50x50andorganizationname' | trans }}</option>
                            <option value="rectangel">{{ 'orgstyle.rectangel200x50' | trans }}</option> 
                          </select>                  
                        </div>
                      </div>  --->
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFour">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">{{ "orgstyle.borders" |
                trans }}</a>
              <label class="font-weight-light f-18 pl-1" *ngIf="!orgstyle.borderRad">{{ "orgstyle.missingsettings" |
                trans }}</label>
            </h5>
          </div>
          <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group row">
                <label for="staticBorderRadius" class="col col-form-label style-label">{{ "orgstyle.borderradius" |
                  trans }}</label>
                <div class="col">
                  <input [ngClass]="{ 'border-danger': !orgstyle.borderRad }" style="font-size: 13px" type="text"
                    class="form-control" id="staticBorderRadius" placeholder="5px" name="borderRad"
                    [(ngModel)]="orgstyle.borderRad" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFive">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">{{ "orgstyle.animations"
                | trans }}</a>
              <label class="font-weight-light f-18 pl-1" *ngIf="!orgstyle.taskanimation">{{ "orgstyle.missingsettings" |
                trans }}</label>
            </h5>
          </div>
          <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group row">
                <label for="taskanimation" class="col col-form-label style-label">{{ "orgstyle.tasktoggleanimation" |
                  trans }}</label>
                <div class="col">
                  <select [ngClass]="{ 'border-danger': !orgstyle.taskanimation }" [(ngModel)]="orgstyle.taskanimation"
                    class="form-control form-control-sm" name="taskanimation">
                    <option value="bounceIn">
                      {{ "orgstyle.default" | trans }}
                    </option>
                    <option value="swing">
                      {{ "orgstyle.swing" | trans }}
                    </option>
                    <option value="wobble">
                      {{ "orgstyle.wobble" | trans }}
                    </option>
                    <option value="bounce">
                      {{ "orgstyle.bounce" | trans }}
                    </option>
                    <option value="rubberBand">
                      {{ "orgstyle.rubberBand" | trans }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col justify-content-center">
                  <button class="btn btn-task border-0 p-0 m-0 bg-transparent task-handler mx-auto d-block center">
                    <span class="material-icons text-center rounded-circle m-1 p-1 text-white cursor-pointer"
                      style="background-color: var(--brand-color-med)">
                      assignment_turned_in
                    </span>
                  </button>
                  <p class="text-center text-muted">
                    {{ "orgstyle.default" | trans }}
                  </p>
                </div>
                <div class="col justify-content-center">
                  <button
                    class="btn btn-task border-0 p-0 m-0 bg-transparent task-handler-swing mx-auto d-block center">
                    <span class="material-icons text-center rounded-circle m-1 p-1 text-white cursor-pointer"
                      style="background-color: var(--brand-color-med)">
                      assignment_turned_in
                    </span>
                  </button>
                  <p class="text-center text-muted">
                    {{ "orgstyle.swing" | trans }}
                  </p>
                </div>
                <div class="col justify-content-center">
                  <button
                    class="btn btn-task border-0 p-0 m-0 bg-transparent task-handler-wobble mx-auto d-block center">
                    <span class="material-icons text-center rounded-circle m-1 p-1 text-white cursor-pointer"
                      style="background-color: var(--brand-color-med)">
                      assignment_turned_in
                    </span>
                  </button>
                  <p class="text-center text-muted">
                    {{ "orgstyle.wobble" | trans }}
                  </p>
                </div>
                <div class="col justify-content-center">
                  <button
                    class="btn btn-task border-0 p-0 m-0 bg-transparent task-handler-bounce mx-auto d-block center">
                    <span class="material-icons text-center rounded-circle m-1 p-1 text-white cursor-pointer"
                      style="background-color: var(--brand-color-med)">
                      assignment_turned_in
                    </span>
                  </button>
                  <p class="text-center text-muted">
                    {{ "orgstyle.bounce" | trans }}
                  </p>
                </div>
                <div class="col justify-content-center">
                  <button
                    class="btn btn-task border-0 p-0 m-0 bg-transparent task-handler-rubberband mx-auto d-block center">
                    <span class="material-icons text-center rounded-circle m-1 p-1 text-white cursor-pointer"
                      style="background-color: var(--brand-color-med)">
                      assignment_turned_in
                    </span>
                  </button>
                  <p class="text-center text-muted">
                    {{ "orgstyle.rubberBand" | trans }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header" id="headingSix">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">{{ "orgstyle.taskoptions" |
                trans }}</a>
              <label class="font-weight-light f-18 pl-1" *ngIf="
                  !orgstyle.taskmytaskbg ||
                  !orgstyle.taskvendorbg ||
                  !orgstyle.taskcustomerbg ||
                  !orgstyle.taskdonebg ||
                  !orgstyle.tasktextcolor
                ">{{ "orgstyle.missingsettings" | trans }}</label>
            </h5>
          </div>
          <div id="collapseSix" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group row pb-3">
                <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.mytaskbackgroundcolor"
                  | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{ 'border-danger': !orgstyle.taskmytaskbg }" style="font-size: 13px" type="color"
                    class="form-control" id="taskmybg" name="taskmybg" [(ngModel)]="orgstyle.taskmytaskbg" />
                </div>
              </div>
              <div class="form-group row pb-3">
                <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.vendorbackgroundcolor"
                  | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{ 'border-danger': !orgstyle.taskvendorbg }" style="font-size: 13px" type="color"
                    class="form-control" id="taskvendorbg" name="taskvendorbg" [(ngModel)]="orgstyle.taskvendorbg" />
                </div>
              </div>
              <div class="form-group row pb-3">
                <label for="staticMainBorder" class="col col-form-label style-label">{{
                  "orgstyle.customerbackgroundcolour" | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{ 'border-danger': !orgstyle.taskcustomerbg }" style="font-size: 13px" type="color"
                    class="form-control" id="taskcustomerbg" name="taskcustomerbg"
                    [(ngModel)]="orgstyle.taskcustomerbg" />
                </div>
              </div>
              <div class="form-group row pb-3">
                <label for="staticMainBorder" class="col col-form-label style-label">{{
                  "orgstyle.finishedtaskbackgroundcolor" | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{ 'border-danger': !orgstyle.taskdonebg }" style="font-size: 13px" type="color"
                    class="form-control" id="taskdonebg" name="taskdonebg" [(ngModel)]="orgstyle.taskdonebg" />
                </div>
              </div>
              <div class="form-group row pb-3 border-bottom">
                <label for="staticMainBorder" class="col col-form-label style-label">{{ "orgstyle.tasktextcolor" | trans
                  }}
                </label>
                <div class="col">
                  <input [ngClass]="{ 'border-danger': !orgstyle.tasktextcolor }" style="font-size: 13px" type="color"
                    class="form-control" id="tasktextcolor" name="tasktextcolor" [(ngModel)]="orgstyle.tasktextcolor" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header" id="headingNine">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseNine, #collapseTen" aria-expanded="false" aria-controls="collapseNine">{{
                "orgstyle.notifications" | trans }}</a>
            </h5>
          </div>
          <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group row pb-3">
                <label for="staticMainBorder" class="col col-form-label style-label">{{
                  "orgstyle.notificationbackgroundcolor" | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{
                      'border-danger': !orgstyle.notificationbgcolor
                    }" style="font-size: 13px" type="color" class="form-control" id="notificationbgcolor"
                    name="notificationbgcolor" [(ngModel)]="orgstyle.notificationbgcolor" />
                </div>
              </div>
              <div class="form-group row pb-3">
                <label for="staticMainBorder" class="col col-form-label style-label">{{
                  "orgstyle.notificationtitlecolor" | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{
                      'border-danger': !orgstyle.notificationtitlecolor
                    }" style="font-size: 13px" type="color" class="form-control" id="notificationtitlecolor"
                    name="notificationtitlecolor" [(ngModel)]="orgstyle.notificationtitlecolor" />
                </div>
              </div>
              <div class="form-group row pb-3 border-bottom">
                <label for="staticMainBorder" class="col col-form-label style-label">{{
                  "orgstyle.notificationdescriptioncolor" | trans }}
                </label>
                <div class="col">
                  <input [ngClass]="{
                      'border-danger': !orgstyle.notificationdescriptioncolor
                    }" style="font-size: 13px" type="color" class="form-control" id="notificationdescriptioncolor"
                    name="notificationdescriptioncolor" [(ngModel)]="orgstyle.notificationdescriptioncolor" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header" id="headingTen">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">{{ "orgstyle.email" | trans
                }}</a>
            </h5>
          </div>
          <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group pb-3">
                <p></p>
                <label for="emailmarkuptextarea">Email markup</label>
                <textarea class="form-control" id="emailmarkuptextarea" rows="10" name="emailmarkup"
                  [(ngModel)]="orgstyle.emailmarkup"></textarea>
              </div>
            </div>
          </div>



          <div class="card-header" id="headingEight">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight"> {{
                "orgstyle.importexport"
                | trans }}</a>
              <label class="font-weight-light f-18 pl-1" *ngIf="
                  !orgstyle.taskmytaskbg ||
                  !orgstyle.taskvendorbg ||
                  !orgstyle.taskcustomerbg ||
                  !orgstyle.taskdonebg ||
                  !orgstyle.tasktextcolor
                ">{{ "orgstyle.missingsettings" | trans }}</label>
            </h5>
          </div>
          <div id="collapseEight" class="collapse" aria-labelledby="collapseEight" data-parent="#accordion">
            <div class="card-body">
              <div class="card-body">
                <p class="text-muted mb-2">
                  {{ "orgstyle.importexport.help" | trans }}
                </p>
                <ul class="small mb-0">
                  <li>{{ "orgstyle.export.help" | trans }}</li>
                  <li>{{ "orgstyle.import.help" | trans }}</li>
                  <li>{{ "orgstyle.merge.help" | trans }}</li>
                </ul>
              </div>
              <div class="form-group">
                <div class="input-group input-group-sm mr-2">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{
                      "orgstyle.sourceorg" | trans
                      }}</span>
                  </div>
                  <input type="text" class="form-control" placeholder="{{ 'orgstyle.sourceorg.placeholder' | trans }}"
                    [(ngModel)]="sourceOrgId" name="sourceOrgId" />
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" (click)="loadFromOrgId()"
                      [disabled]="loadingCopy || !sourceOrgId">
                      <span *ngIf="!loadingCopy">{{
                        "orgstyle.load" | trans
                        }}</span>
                      <span *ngIf="loadingCopy" class="spinner-border spinner-border-sm"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <button type="button" class="btn btn-sm mr-2 ml-2 col" (click)="exportOrgStyle()">
                  <p class="btn-text mb-0">{{ "orgstyle.export" | trans }}</p>
                </button>
                <button type="button" class="btn btn-sm  mr-2 ml-2 col" (click)="triggerImport()">
                  <p class="btn-text mb-0"> {{ "orgstyle.import" | trans }}</p>
                </button>
                <input #fileInput type="file" accept="application/json" style="display: none"
                  (change)="importOrgStyleFile($event)" />
              </div>
              <div *ngIf="importPreview != null" class="form-group">
                <h6 class="modal-title" id="orgStylePreviewLabel">
                  {{ "orgstyle.previewchanges" | trans }}
                </h6>
                <p class="text-muted">
                  {{ "orgstyle.previewchanges.desc" | trans }}
                </p>
                <pre class="bg-light p-2 rounded"
                  style="max-height: 320px; overflow: auto">{{ importPreview | json }}</pre>
              </div>
              <div *ngIf="importPreview != null" class="row">
                <div class="custom-control text-center custom-radio d-inline-block ml-2 mb-2 mr-2 col">
                  <input type="radio" id="applyReplace" name="applyMode" class="custom-control-input"
                    [(ngModel)]="applyMode" [value]="'replace'" />
                  <label class="custom-control-label" for="applyReplace">{{
                    "orgstyle.apply.replace" | trans
                    }}</label>
                </div>
                <div *ngIf="importPreview != null"
                  class="custom-control text-center custom-radio d-inline-block mb-2 ml-2 mr-2 col">
                  <input type="radio" id="applyMerge" name="applyMode" class="custom-control-input"
                    [(ngModel)]="applyMode" [value]="'merge'" />
                  <label class="custom-control-label" for="applyMerge">{{
                    "orgstyle.apply.merge" | trans
                    }}</label>
                </div>
              </div>
              <div *ngIf="importPreview != null" class="row">
                <button type="button" class="btn btn-sm col ml-2 mr-2" data-dismiss="modal">
                  <p class="btn-text mb-0">{{ "orgstyle.cancel" | trans }}</p>
                </button>
                <!-- Replace the Apply button -->
                <button type="button" class="btn btn-sm col ml-2 mr-2" (click)="applyImportedStyle(true)">
                  <p class="btn-text mb-0">{{ 'orgstyle.apply' | trans }}</p>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header" id="headingSeven">
            <h5 class="mb-0">
              <a class="cursor-pointer font-weight-light f-18 collapsed" data-toggle="collapse"
                data-target="#collapseSeven, #collapseEight" aria-expanded="false" aria-controls="collapseSeven">{{
                "orgstyle.reset" | trans }}</a>
            </h5>
          </div>
          <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
            <div class="card-body">
              <div class="form-group row">
                <label for="orgBrandWeight" class="col col-form-label style-label">{{ "orgstyle.stylereset" | trans
                  }}</label>
                <div class="col">
                  <button *ngIf="!resettoggler" (click)="togglereset()" class="btn fa-bgcolor reset-btn">
                    <h6 class="reset-btn-h6">{{ "orgstyle.reset" | trans }}</h6>
                  </button>
                  <button *ngIf="resettoggler" (click)="togglereset()" style="opacity: 0.5"
                    class="btn fa-bgcolor reset-btn">
                    <h6 class="reset-btn-h6">
                      {{ "orgstyle.cancelreset" | trans }}
                    </h6>
                  </button>
                </div>
              </div>
              <div *ngIf="resettoggler" class="alert alert-danger" role="alert">
                {{ "orgstyle.resetwarning" | trans }}
              </div>
            </div>
          </div>
          <div id="collapseSeven" class="collapse collapsed" data-parent="#accordion">
            <div class="row">
              <div *ngIf="resettoggler" class="col">
                <button (click)="togglereset()" class="btn-close float-left mb-3 ml-3 w-75">
                  <h6 class="btn-save-text">
                    {{ "orgstyle.cancelreset" | trans }}
                  </h6>
                </button>
              </div>
              <div *ngIf="resettoggler" class="col">
                <button (click)="resetStyles()" data-toggle="collapse" href="#resetCollapse"
                  class="btn-save float-right w-75 mb-3 mr-3">
                  <h6 class="btn-save-text">
                    {{ "orgstyle.confirmreset" | trans }}
                  </h6>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row mt-3">
        <div class="col">
          <button [ngClass]="{ 'btn fa-bgcolor border-0 reset-btn': resettoggler }" type="button"
            class="btn-close float-left mb-3 ml-3 w-75" data-dismiss="modal">
            <h6 class="btn-save-text">{{ "orgstyle.close" | trans }}</h6>
          </button>
        </div>
        <div class="col">
          <button [ngClass]="{ 'btn fa-bgcolor border-0 reset-btn': resettoggler }" (click)="updateOrgStyle()"
            type="button" data-dismiss="modal" class="btn-save float-right w-75 mb-3 mr-3">
            <h6 class="btn-save-text">{{ "orgstyle.savechanges" | trans }}</h6>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>